export default __webpack_public_path__ + "static/media/left-logo-source.8bdc49ae.png";